import { render, staticRenderFns } from "./SocialSharePost.vue?vue&type=template&id=3a7178bc&scoped=true&"
import script from "./SocialSharePost.vue?vue&type=script&lang=js&"
export * from "./SocialSharePost.vue?vue&type=script&lang=js&"
import style0 from "./SocialSharePost.vue?vue&type=style&index=0&id=3a7178bc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7178bc",
  null
  
)

export default component.exports